import React, { ReactNode } from 'react';
import InfoTooltip, { IInfoTooltipProps } from 'src/app/components/InfoTooltipComponent/InfoTooltip';

interface IInfoTooltipWithLabelProps extends IInfoTooltipProps {
  label: string | ReactNode;
}

// This component render info tooltip with given text
const InfoTooltipWithLabel: React.FC<IInfoTooltipWithLabelProps> = ({ label, tooltipContent, style }) => {
  return (
    <div style={{ display: 'flex' }}>
      <span
        style={{
          whiteSpace: 'nowrap',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          width: '150px',
        }}
        title={label as string}
      >
        {label}
      </span>
      {tooltipContent ? <InfoTooltip tooltipContent={tooltipContent} style={style} /> : null}
    </div>
  );
};

export default InfoTooltipWithLabel;
